// DON'T EXPORT THIS FILE FROM UI LIBRARY
import * as React from 'react';
import { useContext } from 'react';

import { ToastSettings } from '../../../../interfaces';
import { NotificationsStateContext } from '../../contexts/notifications.context';
import { NotificationsState } from '../../notificationsProvider.types';

import { Container, StyledToast } from './toasts.styled';

export const Toasts: React.FC = () => {
  const state: NotificationsState = useContext<NotificationsState>(NotificationsStateContext);

  return (
    <Container>
      {state.toasts.map((toast: ToastSettings) => (
        <StyledToast
          content={toast.content}
          visible
        />
      ))}
    </Container>
  );
};
